import React, { Component } from "react";
import {Modal, Card, Form, Button, Row, Col, Table, Alert, Tab, Tabs, InputGroup, OverlayTrigger, Tooltip, ListGroup, FormLabel, CardBody} from "react-bootstrap";
import CreatableSelect from 'react-select/creatable';
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { formatarValor, formatarValorAPI } from '../../common/utils';
import AsyncSelect from 'react-select/async';
import Paginacao from '../../common/pagination';
import { FaEdit, FaTrash } from "react-icons/fa";
import '../ProgramasV2/ProgramasEdit.module.css';

class ProdutosPrograma extends Component {
    constructor(props) {
        super(props);
        this.state = {
            produtos: [],
            produtoSelecionado: [],
            produtosSelecionados: [],
            programa_id: this.props.programa_id,
            erroLoadRegistro: '',
            loading: false,
            page_numb: this.props.page_numb || 1,
            page_limit: this.props.page_limit || 10
        }
    }

    componentDidMount() {
        this.carregarProdutosPrograma();
    }

    carregarProdutosPrograma = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/produtos/?programa=${this.state.programa_id}&status=1&page=${this.state.page_numb}&page_limit=${this.state.page_limit}`)
            .then(response => {
                this.setState({
                    produtos: {
                        ...response.data,
                        results:response.data.results.map(produto => ({
                            id: produto.id,
                            valor: formatarValor(produto.valor),
                            produto_id: produto.produto_id,
                            produto_nome: produto.dados_produto.nome,
                            status: produto.status,
                            apresentacoes: produto.apresentacoes
                        }))
                    }
                });
            })
            .catch(error => {
                console.error('Erro ao carregar produtos:', error);
                
                let erro_msg = 'Erro ao carregar produtos do programa, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
    }

    handleChangeProduto = (e, campo) => {
        if (campo === 'produto_id') {
            this.setState({ produtoSelecionado: { ...this.state.produtoSelecionado, produto_id: e.value, produto_nome: e.label, valor: e.valor } });
        } else if(campo === 'valor') {
            const { name, value } = e.target;
            this.setState({ produtoSelecionado: { ...this.state.produtoSelecionado, valor: formatarValor(value) } });
        } else {
            const { name, value } = e.target;
            this.setState({ produtoSelecionado: { ...this.state.produtoSelecionado, [name]: value } });
        }
    }

    handleSalvarProduto = async () => {
        const url = this.state.produtoSelecionado.id ? `/programas/produtos/${this.state.produtoSelecionado.id}/` : '/programas/produtos/';
        const metodo = this.state.produtoSelecionado.id ? 'put' : 'post';
    
        const dadosProduto = {
            status: true,
            valor: formatarValorAPI(this.state.produtoSelecionado.valor),
            programa_id: this.state.programa_id,
            produto_id: this.state.produtoSelecionado.produto_id,
            apresentacoes: this.state.produtoSelecionado.apresentacoes
        };

        api({
            method: metodo,
            url: url,
            data: dadosProduto,
        })
        .then(response => {
            
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.produtoSelecionado.id) ? 'Produto atualizado com sucesso' : 'Produto cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })

            this.carregarProdutosPrograma();
            this.handleCloseModalProdutos();
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o produto, verifique os campos e tente novamente';         
            let content = '';   

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'produto_id') {
                        content += `<br>&bull; Produto: ${value}`;
                    }
                    if(key == 'valor') {
                        content += `<br>&bull; Valor: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    }

    removerProduto = (produto) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover produto?',
            text: "Tem certeza que deseja remover o produto #" + produto.produto_nome + "?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                if (produto.id) {
                    const url = `/programas/produtos/${produto.id}/`;
                    const metodo = 'put';
                
                    const dadosProduto = {
                        status: false
                    };
                
                    api({
                        method: metodo,
                        url: url,
                        data: dadosProduto,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Produto removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.carregarProdutosPrograma();
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o produto, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });
                }
            }
        });
    };

    handleShowModalProdutos = (produto = []) => {
        this.setState({ showModalProdutos: true, produtoSelecionado: produto });
    }

    handleCloseModalProdutos = () => {
        this.setState({ showModalProdutos: false, produtoSelecionado: [] });
    }

    onClickPaginaProdutos = (num_page) => {
        this.setState({
            loading: true,
            page_numb: num_page
        }, () => {
            this.carregarProdutosPrograma(num_page)
        });
    };

    adicionarApresentacao = () => {
        this.setState(prevState => ({
            produtoSelecionado: {
                ...prevState.produtoSelecionado, 
                apresentacoes: prevState.produtoSelecionado.apresentacoes 
                    ? [...prevState.produtoSelecionado.apresentacoes, {descricao: '' }]
                    : [{descricao: '' }]
            },
        }));
        };

    handleChangeApresentacao = (e, index) => {
        this.setState(prevState => ({
            produtoSelecionado: {
                ...prevState.produtoSelecionado,
                apresentacoes: prevState.produtoSelecionado.apresentacoes.map((apresentacao, i) => i === index ? { ...apresentacao, descricao: e.target.value } : apresentacao)
            },
        }));
    };

    removerApresentacao = (index) => {
        this.setState(prevState => ({
            produtoSelecionado: {
                ...prevState.produtoSelecionado,
                apresentacoes: prevState.produtoSelecionado.apresentacoes.filter((_, i) => i !== index)
            },
        }));
    };

    //Carrega produtos para o modal de adição de produtos
    carregarProdutos = async (inputValue) => {
        if(!this.state.focusProdutoPrograma) {
            return [];
        }

        try {
            const response = await api.get(`/produtos/?nome=${inputValue}&status=1`);
            const opcoes = response.data.results.map(produto => ({
                value: produto.id,
                label: produto.nome,
                valor: formatarValor(produto.valor)
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar produtos:', error);
            return [];
        }
    };


    render() {
        return (
            <>
            <Card className="cardDestaque mt-4">
                <Card.Body>                   
                    <Row className="align-items-center mb-3">
                        <Col sm={6} lg={6}>
                            <h6><strong>Produtos do Programa</strong></h6>
                        </Col>
                        <Col sm={6} xs={6} className="text-end">                       
                            <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalProdutos()}>
                                {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Adicionar Produto'}                                       
                            </Button>
                        </Col>
                    </Row>
                    {('results' in this.state.produtos && this.state.produtos.results.length > 0) ? (
                        <Row>
                            <Col sm={12} lg={12}>
                                <Table responsive className="custom-table">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>#ID /Produto</th>
                                            <th>Valor</th>
                                            <th>Status</th>  
                                            <th>Opções</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.produtos.results.map((produto, index) => ( 
                                            <tr key={index}>
                                                <td className="bg-id">#{produto.id}</td>
                                                <td className="td-border">{"#" + produto.produto_id + " - " + produto.produto_nome}</td>
                                                <td className="td-border">{produto.valor}</td>
                                                <td className="td-border">{produto.status ? 'Ativo' : 'Inativo'}</td>
                                                <td>
                                                    <Button variant="secondary" size="sm" className="me-2" onClick={() => this.handleShowModalProdutos(produto)}>
                                                        <FaEdit /> Editar
                                                    </Button>  
                                                    <Button variant="danger" size="sm" className="me-2" onClick={() => this.removerProduto(produto)}>
                                                        <FaTrash /> Remover
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                    {'results' in this.state.produtos && this.state.produtos.results.length > 0 && (
                                        <Paginacao dados={this.state.produtos} limit={this.state.page_limit} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPaginaProdutos} />
                                    )}
                            </Col>
                        </Row>   
                    ) : (
                        <p>Nenhum produto cadastrado até o momento</p>
                    )}
                            
                </Card.Body>                
            </Card>

            <Modal show={this.state.showModalProdutos} onHide={this.handleCloseModalProdutos}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {this.state.produtoSelecionado.id ? 'Editar Produto #' + this.state.produtoSelecionado.id : 'Adicionar Produto'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col sm={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Produto</Form.Label>
                                    <AsyncSelect
                                        key={this.state.focusProdutoPrograma}
                                        loadOptions={(inputValue) => {
                                            return new Promise((resolve) => {
                                                clearTimeout(this.produtoProgramaSearchTimeout);
                                                this.produtoProgramaSearchTimeout = setTimeout(() => {
                                                    resolve(this.carregarProdutos(inputValue));
                                                }, 700);
                                            });
                                        }}
                                        onFocus={() => {
                                            this.setState({
                                                focusProdutoPrograma: true
                                            });
                                        }}
                                        autoFocus={this.state.focusProdutoPrograma}
                                        openMenuOnFocus={this.state.focusProdutoPrograma}
                                        defaultOptions
                                        name="produto_id"
                                        placeholder="Buscar produto..."
                                        noOptionsMessage={() => "Nenhum produto encontrado"}
                                        onChange={e => this.handleChangeProduto(e, 'produto_id')}
                                        value={this.state.produtoSelecionado.produto_id ? { value: this.state.produtoSelecionado.produto_id, label: this.state.produtoSelecionado.produto_nome } : null}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Valor</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="valor"
                                        value={this.state.produtoSelecionado.valor} 
                                        onChange={e => this.handleChangeProduto(e, 'valor')}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <Card>
                                    <Card.Body>
                                        <h4>Apresentações</h4>
                                        {this.state.produtoSelecionado.apresentacoes && this.state.produtoSelecionado.apresentacoes.length > 0 ? (
                                            this.state.produtoSelecionado.apresentacoes.map((apresentacao, index) => (
                                                <div key={index} className="row-list">
                                                    <Row>
                                                        <Col sm={8}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Apresentação #{index + 1}</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="descricao"
                                                                    value={apresentacao.descricao}
                                                                    onChange={e => this.handleChangeApresentacao(e, index)}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={4} className="d-flex justify-content-end align-items-end pb-3"> 
                                                            <Button  variant="danger" size="sm" onClick={() => this.removerApresentacao(index)}>
                                                                <FaTrash /> Remover
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            ))
                                        ) : (
                                            <p>Nenhuma apresentação cadastrada</p>
                                        )}
                                    </Card.Body>
                                    <Card.Footer>
                                        <Row>
                                            <Col sm={12} className="text-end">
                                                <Button variant="primary" size="sm" onClick={this.adicionarApresentacao}>Adicionar</Button>
                                            </Col>
                                        </Row>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleCloseModalProdutos}>
                        Fechar
                    </Button>
                    <Button variant="primary" onClick={this.handleSalvarProduto}>
                        Salvar
                    </Button>
                </Modal.Footer>
            </Modal>
            </>
        );
    }
}

export default ProdutosPrograma;

